import React, {
  Component,
  MouseEvent,
  ReactNode,
  useEffect,
  useState,
} from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import axios from "axios";
import { useStore } from "../store";
import Card from "react-bootstrap/Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IconDefinition,
  faCalendarDays,
  faUpload,
  faTag,
  faHashtag,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";

type Prop = {
  index: number;
  title?: string;
  children?: ReactNode;
  width?: string;
  titleHeight?: string;
  icone?: IconDefinition;
  type?: string;
  description?: string;
};
function CardComponentGoalsLida(props: Prop) {
  const [viewSamples, setViewSamples] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const { instructions, setInstructions } = useStore();
  const { visualisationType, setVisualisationType } = useStore();
  const [inputValue, setInputValue] = useState<string>("");
  const handleHover = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleOnclick = () => {
    props.title && setInstructions(props.title);

    props.type && setVisualisationType(props.type);


  };
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          maxWidth: "25rem",
          minWidth: "20rem",
        }}
      >
        <Card
          style={{
            width: props.width ? props.width : "100%",
            backgroundColor: "#e5e4e2",
            borderColor: isHovered ? "green" : "",
            cursor: "pointer",
          }}
          onMouseOver={handleHover}
          onMouseLeave={handleMouseLeave}
          onClick={handleOnclick}
        >
          <Card.Body className="text-center">
            {props.title ? (
              <div
                style={{ display: "flex", alignItems: "centre", gap: "0.5rem" }}
              >
                {/* Icon */}
                <div
                  style={{
                    fontSize: "20px",
                    color: "green",
                  }}
                >
                  {props.index + "."}
                </div>
                <div
                  style={{
                    textAlign: "left",
                    fontSize: "18px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {props.title}
                </div>
              </div>
            ) : null}
            {props.type && (
              <div
                style={{
                  fontSize: "18px",
                  textAlign: "left",
                  color: "green",
                }}
              >
                {props.type}
              </div>
            )}
            {props.description && (
              <div
                style={{
                  textAlign: "left",
                }}
              >
                {props.description}
              </div>
            )}
          </Card.Body>
        </Card>
      </div>
    </>
  );
}

export default CardComponentGoalsLida;
